<template>
  <v-app v-scroll="onScroll">
    <search-top-bar :app-bar-top-props="appBarTopProps" />

    <v-main>
      <router-view />
    </v-main>

    <common-bottom-bar :app-bar-bottom-props="appBarBottomProps"
                       :current-scroll="currentScroll"
    />
  </v-app>
</template>

<script>

import { searchAppBarPropMixin } from '@/mixins/searchAppBarPropMixin';
import SearchTopBar from '@/components/layouts/SearchLayout/SearchTopBar';
import CommonBottomBar from '@/components/layouts/common/CommonBottomBar';

export default {
  name: 'SearchLayout',
  components: { SearchTopBar, CommonBottomBar },
  mixins: [searchAppBarPropMixin],
  data: () => ({}),
  computed: {},
  methods: {},
};

</script>
